import { useMutation, useQueryClient } from '@tanstack/react-query';

import { normalizeAccess, type RoleGrant } from '../../../domain/access';
import type { UpdateMemberAccessBody } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

/**
 * `PATCH /v1/users/:id` — remplace **l'ensemble** des rôles et périmètres d'un
 * membre (204). `access: []` révoque tout et coupe l'accès extranet.
 * Réservé au profil `Extranet_Admin`.
 */
export const useUpdateMemberAccess = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, access }: { id: string; access: RoleGrant[] }) =>
      getExtranetApi().patch<UpdateMemberAccessBody, void>(`/v1/users/${encodeURIComponent(id)}`, {
        access: normalizeAccess(access),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: extranetQueryKeys.members.root() });
      // L'admin peut avoir modifié ses propres accès.
      queryClient.invalidateQueries({ queryKey: extranetQueryKeys.account.me() });
    },
  });
};
